export default __webpack_public_path__ + "images/4c238db66d80f4d28c059ecee8b4f4fd.png";